// @flow

export { PixPageContent } from './page-content';
